import { Injectable, inject } from '@angular/core';

import { PermissionConstants } from '../constants/permission-constants';
import { CoreDataService } from '../services/core-data.service';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { DimensionRange, ListPermissionsResponse, PermissionDto } from '../api/clients';

@Injectable({
  providedIn: 'root',
})
export class HandlePermissions {
  private readonly coreDataService = inject(CoreDataService);


  getRoles(): string[] | undefined {
    let roles: string[] = [];
    this.coreDataService.listPermissions().subscribe((listPermissionsResponse: ListPermissionsResponse) => {
      roles = listPermissionsResponse.userRoles!;
    });
    return roles;
  }

  async getPermissionsAndRoles(): Promise<ListPermissionsResponse> {
    return await firstValueFrom(this.coreDataService.listPermissions());
  }

  async getPermissions(): Promise<PermissionDto[]> {
    return await firstValueFrom(
      this.coreDataService.listPermissions().pipe(
        map((resp) => {
          return resp.permissionsListItemDtos!;
        })
      )
    );
  }

  getPermission(permissionName: PermissionConstants, permissionsDto: PermissionDto[] | undefined): PermissionDto | undefined {
    const permission = permissionsDto?.find((p) => p.permissionName === permissionName);
    return permission;
  }
  checkIfPermissionNotAllowed(
    permissionName: PermissionConstants,
    tenantCodes: string[],
    permissionsDto: PermissionDto[] | undefined
  ): boolean {
    if (!permissionsDto) {
      return true;
    }

    const permission = permissionsDto.find((p) => p.permissionName === permissionName);

    if (!permission) {
      return true;
    }

    if (permission.tenantRange === DimensionRange.ALL) {
      return false;
    }
    const tenantMatch = permission.tenantValues?.some((t) => tenantCodes.includes(t));

    if (tenantMatch) {
      return false;
    }
    return true;
  }
}
